import { useQueryClient } from '@tanstack/react-query';
import { useAuth, useUserDetails } from '../../zustand';

export const useLogout = () => {
  const queryClient = useQueryClient();
  const { clearToken } = useAuth((s) => s);
  const { resetUserDetails } = useUserDetails((s) => s);
  const handleLogout = () => {
    clearToken();
    resetUserDetails();
    // Everything cached belongs to the account that just left. Keeping it lets
    // the next account on this tab read the previous one's answers — setup
    // status, lists, details — until each happens to refetch.
    queryClient.clear();
    document.title = "Rorotel";
  };
  return { handleLogout };
};
